import ReactDOM from 'react-dom';
import galmap from '../../assets/route-icon.svg'
import { FaCircle } from 'react-icons/fa6';

const ItinerariesModal = ({ isOpen, onClose, state, donwload }) => {

    if (!isOpen) return null;
 
    return ReactDOM.createPortal(
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black/40 backdrop-blur-sm z-50">
            <div className="modal-box p-0 w-[100%] md:max-w-[750px] md:max-h-max contenedor bg-fixed rounded-md">
                <button onClick={onClose} className="z-20 border-none text-gray-700 btn btn-sm btn-circle bg-rose-200 hover:bg-rose-400 absolute right-2 top-2">✕</button>
                <div className="flex flex-col justify-center items-center w-full transition-all h-full bg-cover bg-center bg-white/70">
                    <div className="relative z-10 p-3 flex flex-col justify-start gap-3 text-[#2e6a82]">
                        <h3 className="py-[2px] px-1 font-bold text-center text-[28px] md:text-[50px] uppercase text-shadow-lg">{state.name}</h3>
                        <div className='grid md:grid-cols-2 gap-1 md:gap-3 justify-center items-center'>
                            <div className='flex flex-col gap-3 p-5'>
                                <div className="flex gap-3 text-[18px] items-center ">
                                    <span className="bg-[#2e6a82] py-[2px] px-3 font-semibold uppercase text-white ">
                                        {state.route}
                                    </span>
                                    <p className="font-semibold">{state.routeOption}</p>
                                </div>
                                <div className="text-[18px]  font-semibold text-start">
                                    <p>
                                        Departures on <span className="text-[#f29100]" >{state.departure}</span>
                                    </p>
                                    <p>
                                        Returns on <span className="text-[#f29100]">{state.return}</span>
                                    </p>
                                </div>
                            </div>
                            <div className='flex justify-center items-center p-3 bg-gradient-to-b from-[#051937] to-[#004d7a] rounded-md'>
                                <img className='w-[150] h-[150]' src={galmap} alt="galapagos" />
                            </div>
                        </div>
                        <div className='flex justify-center md:text-start items-center'>
                            <h2 className='font-bold text-[25px] md:text-[35px] text-[#2e6a82] text-shadow-lg uppercase'>Island</h2>
                            <h2 className='text-[50px] md:text-[50px] leading-none text-amber-500 text-shadow-lg pt-2' style={{ fontFamily: 'BloomingHeart' }}>Included</h2>
                        </div>
                        <div className='grid grid-cols-2 md:grid-cols-4 items-center gap-3 justify-center p-3'>
                            {
                                state.islandsIncluded.map(island => (
                                    <p key={island} className='font-bold text-[15px] text-[#2e6a82] text-shadow-lg uppercase flex items-center gap-2'><FaCircle /> {island}</p>
                                ))
                            }
                        </div>
                    </div>
                    <button
                        onClick={donwload}
                        className="duration-300 bg-[#f29100] my-3 hover:scale-110 shadow-md shadow-black text-[18px] px-5 py-2 font-bold  text-white"
                    >
                       Download itinerary
                    </button>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root') // Asegúrate de tener un elemento con id 'modal-root' en tu HTML
    );
};

export default ItinerariesModal;